import React, { useState } from 'react';
import DashCountDetail from '../../../components/atoms/DashCountDetail';
import { get } from '../../../services/apiController';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { dateFormat } from '../../../util/helper';
import LocationType from '../../../components/LocationTypeAndLocation/LocationType';
import LocationDropdown from '../../../components/LocationTypeAndLocation/Location';
import { DEBOUNCE_DELAY } from '../../../util/constant';
import useDebounce from '../../useDebounce';
import AgreementAddEditModal from '../components/AgreementAddEditModal';
import MarkShopCloseModal from '../components/MarkShopCloseModal';

const AgreementDashBoard = () => {
  const [counts, setCounts] = useState({
    totalCount: 0,
    uniqueBranchCount: 0,
    uniquePanCardCount: 0,
  });
  const [upcomingRenewals, setUpcomingRenewals] = useState([]);
  const [overdueRenewals, setOverdueRenewals] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [shopCloseModal, setShopCloseModal] = useState(false);
  const [agreementId, setAgrId] = useState(null);
  const [filters, setFilters] = useState({
    locationType: '',
    locationId: '',
  });
  const navigate = useNavigate();

  const handleFilterChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const FetchDashboardData = () => {
    get(`/agreements/dashboard/statistics/?locationType=${filters.locationType}&locationId=${filters.locationId}`)
      .then((res) => {
        const { totalCount, uniqueBranchCount, uniquePanCardCount } = res?.data?.counts;
        setCounts({
          totalCount,
          uniqueBranchCount,
          uniquePanCardCount,
        });
        setUpcomingRenewals(res.data.upcomingRenewals);
        setOverdueRenewals(res.data.overdueRenewals);
      })
      .catch((err) => toast.error(err?.response?.data?.data?.message || err?.response?.data?.message || err?.message));
  };

  useDebounce(
    () => {
      FetchDashboardData();
    },
    [filters],
    DEBOUNCE_DELAY
  );

  const dashCounts = [
    {
      link: '/agr/agreement-list',
      title: 'Locations',
      value: counts.uniqueBranchCount,
    },
    {
      link: '/agr/agreement-list',
      title: 'Agreements',
      value: counts.totalCount,
    },
    {
      link: '/agr/agreement-list',
      title: 'Owners',
      value: counts.uniquePanCardCount,
    },
  ];

  const AgreementListing = ({ agreements, type }) => {
    return (
      <div className="card">
        <div className="card-body p-0">
          {!agreements || agreements.length === 0 ? (
            <div className="alert alert-warning mb-0" role="alert">
              <strong>No data available</strong>
            </div>
          ) : (
            <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
              <Table responsive striped bordered className="bill-detail-table">
                <thead>
                  <tr>
                    <th>Location</th>
                    <th>Ref. Location</th>
                    <th>Owners</th>
                    <th>Executed Date</th>
                    <th>Effective Date</th>
                    <th>End Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {agreements?.map((item, index) => (
                    <tr key={index}>
                      <td className={(item.isShopClosed || item.isPreClosed) && 'highlightCell'}>{item.Branch.name}</td>
                      <td className={(item.isShopClosed || item.isPreClosed) && 'highlightCell'}>
                        <Link to={`/agr/agreement-list/${item.id}`}>{item.referenceLocation}</Link>
                      </td>
                      <td className={(item.isShopClosed || item.isPreClosed) && 'highlightCell'}>
                        {item?.OwnerDetails?.map((owner) => (
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item p-0">
                              <p className="mb-0">{owner.ownerName}</p>
                              <p className="mb-0">{owner.ownerPhoneNo}</p>
                            </li>
                          </ul>
                        ))}
                      </td>
                      <td className={(item.isShopClosed || item.isPreClosed) && 'highlightCell'}>
                        {dateFormat(item?.agreementExecutedDate)}
                      </td>
                      <td className={(item.isShopClosed || item.isPreClosed) && 'highlightCell'}>{dateFormat(item?.effectiveDate)}</td>
                      <td className={(item.isShopClosed || item.isPreClosed) && 'highlightCell'}>{dateFormat(item?.agreementEndDate)}</td>
                      {item.isShopClosed ? (
                        <td className="highlightCell">Shop Closed</td>
                      ) : item.isPreClosed ? (
                        <td className="highlightCell">Pre-Closed</td>
                      ) : (
                        <td className="d-flex">
                          <span
                            onClick={() => {
                              setShowModal(true);
                              setAgrId(item.id);
                            }}
                            className="text-white text-center rounded-2 p-1"
                            style={{ cursor: 'pointer', backgroundColor: '#90c', marginRight: '10px' }}
                          >
                            Renew Now
                          </span>
                          <span
                            onClick={() => {
                              setShopCloseModal(true);
                              setAgrId(item.id);
                            }}
                            className="text-white text-center rounded-2 p-1"
                            style={{ cursor: 'pointer', backgroundColor: 'orange' }}
                          >
                            Mark as Closed
                          </span>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="row">
        <div className="form-group col-md-2 col-lg-2">
          <label>Location Type</label>
          <LocationType name="locationType" value={filters.locationType} handleChange={handleFilterChange} />
        </div>
        <div className="form-group col-md-2 col-lg-2">
          <label>Location</label>
          <LocationDropdown
            name="locationId"
            value={filters.locationId}
            locationType={filters.locationType}
            handleChange={handleFilterChange}
          />
        </div>
      </div>
      <div className="dash-count-parent-wrapper">
        {dashCounts.map((item, index) => (
          <DashCountDetail key={index} link={item.link} title={item.title} caption={item.caption} value={item.value} />
        ))}
      </div>
      <div className="dash-parent-wrapper">
        <div className="dash-card">
          <div className="header-title">Upcoming Renewals (Next 1 Year)</div>
          <AgreementListing agreements={upcomingRenewals} type="upcoming" />
        </div>
        <div className="dash-card">
          <div className="header-title">Overdue Renewals</div>
          <AgreementListing agreements={overdueRenewals} type="overdue" />
        </div>
      </div>
      {showModal && (
        <AgreementAddEditModal
          open={showModal}
          onClose={() => {
            setShowModal(false);
            setAgrId(null);
          }}
          agreementId={agreementId}
          callback={() => navigate(`/agr/agreement-list/${agreementId}`)}
          step={5} // step 5 is for renew the agreement only
          ownerDetailId={null}
        />
      )}
      {shopCloseModal && (
        <MarkShopCloseModal
          agreementId={agreementId}
          open={shopCloseModal}
          onClose={() => {
            setShopCloseModal(false);
            setAgrId(null);
          }}
          callback={FetchDashboardData}
        />
      )}
    </React.Fragment>
  );
};

export default AgreementDashBoard;
